const registrantTypeByUserType = {
    school: 'school',
    community: 'communityOrganization',
    independent: 'individualLearner',
};
const track = (payload) => {
    window?.intuit?.tracking?.ecs?.webAnalytics?.track?.(payload);
};
const getRegistrantType = (userType) => userType ? registrantTypeByUserType[userType] : undefined;
const getViewedScreen = (currentStep, userType) => {
    if (currentStep === 0) {
        return 'select_reg_type';
    }
    if (!userType) {
        return undefined;
    }
    if (userType === 'school') {
        if (currentStep === 1)
            return 'find_your_school';
        if (currentStep === 2)
            return 'register_your_school';
        if (currentStep === 3)
            return 'registration_confirmation';
        return undefined;
    }
    if (userType === 'community') {
        if (currentStep === 1)
            return 'register_your_org';
        if (currentStep === 2)
            return 'registration_confirmation';
        return undefined;
    }
    if (userType === 'independent') {
        if (currentStep === 1)
            return 'register_learner';
        if (currentStep === 2)
            return 'registration_confirmation';
        return undefined;
    }
    return undefined;
};
const getCurrentScreen = (currentStep, userType) => {
    if (!userType) {
        return undefined;
    }
    if (userType === 'school') {
        if (currentStep === 1)
            return 'find_your_school';
        if (currentStep === 2)
            return 'register_your_school';
        return undefined;
    }
    if (userType === 'community') {
        if (currentStep === 1)
            return 'register_your_org';
        return undefined;
    }
    if (userType === 'independent') {
        if (currentStep === 1)
            return 'register_learner';
        return undefined;
    }
    return undefined;
};
// Registration flow, per-step screen render.
// Page viewed tracking.
export const trackViewed = (currentStep, userType) => {
    const screen = getViewedScreen(currentStep, userType);
    if (!screen) {
        return;
    }
    track({
        object: 'content',
        action: 'viewed',
        ui_object: 'screen',
        ui_action: 'viewed',
        scope_area: 'hof_reg',
        screen,
        registrant_type: getRegistrantType(userType),
    });
};
// Registration flow, per-step navigation button click.
// Button clicked tracking.
export const trackNavigationButtonClicked = (currentStep, buttonText, userType) => {
    if (currentStep === 0 && userType) {
        track({
            object: 'content',
            action: 'engaged',
            ui_object: 'button',
            ui_action: 'clicked',
            object_detail: 'hof_reg_select_reg_type',
            ui_object_detail: buttonText,
            registrant_type: getRegistrantType(userType),
        });
        return;
    }
    const screen = getCurrentScreen(currentStep, userType);
    if (!screen) {
        return;
    }
    track({
        object: 'content',
        action: 'engaged',
        ui_object: 'button',
        ui_action: 'clicked',
        ui_object_detail: buttonText,
        scope_area: 'hof_reg',
        screen,
        registrant_type: getRegistrantType(userType),
    });
};
